import script from "./BlockFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockFilter.vue?vue&type=script&setup=true&lang=js"

import "./BlockFilter.vue?vue&type=style&index=0&id=9337fd46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9337fd46"]])

export default __exports__